import { AutogenLayoutARAgingReport } from "./autogen/AutogenLayoutARAgingReport";

export class ARAgingReport extends AutogenLayoutARAgingReport {
    reportName = "AR Aging";
    override onLoad() {
        this.textboxReportBy.selectedItem = this.textboxReportBy.items[0];
        this.textboxReportType.selectedItem = this.textboxReportType.items[0];
    }
}
